import { type OnereDTO } from '@framework/api-client/api/inquiries-compile/schemas/onereDTO.ts';
import { TableData } from '@framework/ui/components/table/TableData.tsx';
import { useMemo } from 'react';
import { getBurdenColumns } from './burdenColumns.tsx';

interface ISummaryPaymentBurdenTableProps {
  burdens: OnereDTO[];
}

/**
 * Tabella degli oneri associati a un pagamento,
 *  mostrata come dettaglio espandibile nella sezione pagamenti.
 */
export function SummaryPaymentBurdenTable(
  props: ISummaryPaymentBurdenTableProps,
) {
  const { burdens } = props;

  const columns = useMemo(() => getBurdenColumns(burdens), [burdens]);

  return (
    <TableData
      size="small"
      pagination={false}
      dataSource={burdens}
      columns={columns}
      rowKey={(record: OnereDTO, index) => record.id ?? String(index)}
    />
  );
}
